var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Search / Magnifer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5625 5.15625C12.5016 5.15625 5.15625 12.5016 5.15625 21.5625C5.15625 30.6234 12.5016 37.9688 21.5625 37.9688C30.6234 37.9688 37.9688 30.6234 37.9688 21.5625C37.9688 12.5016 30.6234 5.15625 21.5625 5.15625ZM2.34375 21.5625C2.34375 10.9483 10.9483 2.34375 21.5625 2.34375C32.1767 2.34375 40.7812 10.9483 40.7812 21.5625C40.7812 26.3635 39.0209 30.7533 36.1104 34.1216L42.2444 40.2556C42.7935 40.8048 42.7935 41.6952 42.2444 42.2444C41.6952 42.7935 40.8048 42.7935 40.2556 42.2444L34.1216 36.1104C30.7533 39.0209 26.3635 40.7812 21.5625 40.7812C10.9483 40.7812 2.34375 32.1767 2.34375 21.5625Z",
    fill: "#28255F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifer);
export default __webpack_public_path__ + "static/media/magnifer.b647e45c359dfa6d6e9eb5d2cfb06edb.svg";
export { ForwardRef as ReactComponent };